import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptBR from '../locales/pt-BR.json';
import en from '../locales/en.json';
import es from '../locales/es.json';

// Get browser language or fallback to pt-BR
const getBrowserLanguage = (): string => {
  const browserLang = navigator.language.toLowerCase();
  
  // Match exact locale
  if (browserLang === 'pt-br') return 'pt-BR';
  if (browserLang === 'en' || browserLang.startsWith('en-')) return 'en';
  if (browserLang === 'es' || browserLang.startsWith('es-')) return 'es';
  
  // Match language prefix
  if (browserLang.startsWith('pt')) return 'pt-BR';
  
  // Default to pt-BR
  return 'pt-BR';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { translation: ptBR },
      en: { translation: en },
      es: { translation: es },
    },
    lng: getBrowserLanguage(),
    fallbackLng: 'pt-BR',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;

